import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const sizes = {
  sm: 'h-30 xl:h-20 md:h-14',
  xmd: 'h-[140px] xl:h-24 lg:h-20 md:h-14',
  md: 'h-40 xl:h-30 lg:h-20 md:h-14',
  lg: 'h-50 xl:h-40 lg:h-20 md:h-14',
  xl: 'h-60 xl:h-50 lg:h-20 md:h-14',
};

const Spacing = ({ size, theme }) => (
  <div className={clsx(sizes[size], theme === 'gray' && 'bg-new-gray-2')} aria-hidden />
);

Spacing.propTypes = {
  size: PropTypes.oneOf(Object.keys(sizes)).isRequired,
  theme: PropTypes.oneOf(['white', 'gray']),
};

Spacing.defaultProps = {
  theme: 'white',
};

export default Spacing;
